import { httpWithAuth } from '~/clients';
import { REMOVE_FAVORITE } from '~/constants/endpoints';

export default function removeFavorite(vehicleId: number) {
  return httpWithAuth.post(REMOVE_FAVORITE, {
    vehicleId
  });
}
